// LICENSE_CODE ZON
'use strict'; /*jslint node:true, react:true*/
define(['react', 'uikit'], (React, {Tooltip})=>
{
const E = {};

const Overflow_tooltip = props=>{
    const {max_height, tooltip, placement, children,
        fixed_height = true} = props;
    const ref = React.useRef();
    const [is_overflowed, set_is_overflowed] = React.useState(false);
    React.useEffect(()=>{
        const el = ref.current;
        set_is_overflowed(!!el && (el.scrollWidth > el.clientWidth ||
            !!max_height && el.scrollHeight > el.clientHeight));
    }, [max_height]);
    const tip = is_overflowed ? tooltip||children : undefined;
    const className = max_height&&is_overflowed ? 'tooltip_ellipsis' :
        undefined;
    const style = {overflow: 'hidden', textOverflow: 'ellipsis'};
    if (max_height)
    {
        if (fixed_height)
            style.height = max_height;
        style.maxHeight = max_height;
    }
    else
        style.whiteSpace = 'nowrap';
    return <Tooltip tooltip={tip} placement={placement}>
      <div ref={ref} style={style} className={className}>{children}</div>
    </Tooltip>;
};
E.Overflow_tooltip = Overflow_tooltip;

return E; });
